<template>
    <div>
        <input type=text
            v-model="text"
            :placeholder="placeholder"
            @focus="change"
            @blur="blur"
            ref="search"
            @keyup.enter="search" />
        <div class=search-btn
            @click="search"></div>
    </div>
</template>

<script>
export default {
    name: 'searchInputGray',
    props:{
        placeholder:{
            type:String,
            default:''
        }
    },
    data(){
        return {
            text:''
        }
    },
    watch:{
        text(){
            this.$emit('change',this.text)
        }
    },
    methods: {
        search() {
            this.$emit('search',this.text)
        },
        change(){
            this.$emit('change',this.text)
            this.$refs.search.style.border = '1px solid #00ccff'
        },
        blur(){
            this.$emit('blur')
            this.$refs.search.style.border = '1px solid #404649'
        }
    }
}
</script>

<style lang="scss" scoped>
$input-gray: #9f9f9f;
$input-height: 30px;

div {
    position: relative;
    display: inline-block;
    height: $input-height;
    line-height: $input-height;
    &::before {
        content: "";
        display: block;
        width: 1px;
        height: 24px;
        background: $input-gray;
        position: absolute;
        right: 32px;
        top: 3px;
    }
    // &::after {
    //     content: "";
    //     display: block;
    //     width: 14px;
    //     height: 14px;
    //     background: url(../../assets/img/icon/search-icon.png) no-repeat;
    //     position: absolute;
    //     right: 9px;
    //     top: 8px;
    //     z-index: 1;
    // }
}
.search-btn {
    width: 30px;
    height: 30px;
    background: url(../../assets/img/icon/search-icon.png) center no-repeat;
    position: absolute;
    right: 0px;
    top: 0px;
    z-index: 1;
    cursor: pointer;
}
input {
    background: #404649;
    height: $input-height;
    color: #fff;
    width: 224px;
    padding-left: 8px;
    padding-right: 38px;
    border: 1px solid #404649;
    transition: border .5s;
}
</style>

